import { render, staticRenderFns } from "./exampleSay.vue?vue&type=template&id=bdf592fc&"
import script from "./exampleSay.vue?vue&type=script&lang=js&"
export * from "./exampleSay.vue?vue&type=script&lang=js&"
import style0 from "./exampleSay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports